import { Reveal, SectionHead } from "@/components/motion";

const PILLARS = [
  {
    num: "01",
    title: "Investment & Feasibility",
    note: "Reading a site, market and operating assumptions as one investment case.",
    items: ["Market Analysis", "Demand Assessment", "Hotel Positioning", "Financial Feasibility"],
  },
  {
    num: "02",
    title: "Revenue & Commercial Analytics",
    note: "Connecting demand, pricing and profitability.",
    items: ["Revenue Management", "Forecasting", "Total Revenue Strategy", "Commercial KPIs"],
  },
  {
    num: "03",
    title: "Hospitality Strategy & Advisory",
    note: "Moving from evidence to a clear commercial recommendation.",
    items: ["Market Research", "Competitor Benchmarking", "Strategic Analysis", "Recommendations"],
  },
  {
    num: "04",
    title: "Hotel Operations",
    note: "Understanding the property-level context behind the numbers.",
    items: ["F&B Operations", "Guest Behaviour", "Departmental Performance", "Operational Coordination"],
  },
];

export default function Expertise() {
  return (
    <section id="expertise" className="border-t border-hairline bg-stone2/50" data-testid="expertise-section">
      <div className="mx-auto max-w-[1400px] px-6 py-28 sm:px-10 sm:py-36">
        <SectionHead
          label="Expertise"
          title={<>How I approach <em className="text-moss">hospitality problems.</em></>}
          sub="Four pillars — three analytical, one earned on property."
        />

        <div className="grid grid-cols-1 gap-px border border-hairline bg-hairline md:grid-cols-2">
          {PILLARS.map((p, i) => (
            <Reveal key={p.num} delay={i * 0.06} y={24} className="group bg-paper p-8 transition-colors duration-500 hover:bg-stone2 sm:p-12" data-testid={`pillar-${p.num}`}>
              <div className="flex items-baseline justify-between">
                <span className="font-serif text-6xl font-light text-champagne transition-colors duration-500 group-hover:text-moss sm:text-7xl" aria-hidden="true">
                  {p.num}
                </span>
                <span className="hidden h-px w-16 bg-hairline sm:block" aria-hidden="true" />
              </div>
              <h3 className="mt-6 font-serif text-3xl font-light text-ink">{p.title}</h3>
              <p className="mt-2 font-serif text-lg italic text-fog">{p.note}</p>
              <ul className="mt-8 grid grid-cols-1 gap-x-8 sm:grid-cols-2">
                {p.items.map((item) => (
                  <li key={item} className="border-t border-hairline py-2.5 text-[13px] font-medium tracking-wide text-smoke">
                    {item}
                  </li>
                ))}
              </ul>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
